(() => {
  'use strict';
  if (window.__ppaLogoVideoV2) return;
  window.__ppaLogoVideoV2 = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const initialized = new WeakSet();
  const allowed = () => !reduced.matches && !(connection && connection.saveData);
  const update = () => {
    document.querySelectorAll('[data-ppa-logo-video]').forEach(root => {
      const video = root.querySelector('video');
      if (!video) return;
      if (!initialized.has(video)) {
        initialized.add(video);
        root.classList.remove('is-video-playing');
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.addEventListener('canplay', update);
        video.addEventListener('playing', () => {
          if (allowed()) root.classList.add('is-video-playing');
        });
        video.addEventListener('error', () => root.classList.remove('is-video-playing'));
        video.addEventListener('emptied', () => root.classList.remove('is-video-playing'));
      }
      if (!allowed()) {
        video.autoplay = false;
        video.pause();
        root.classList.remove('is-video-playing');
        return;
      }
      if (document.hidden) { video.pause(); return; }
      video.autoplay = true;
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      if (video.paused) {
        const play = video.play();
        if (play && play.catch) play.catch(() => root.classList.remove('is-video-playing'));
      }
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  };
  const start = () => {
    update();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches('[data-ppa-logo-video], [data-ppa-logo-video] video') || node.querySelector('[data-ppa-logo-video]'))
      ))) schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('focus', update);
  document.addEventListener('pointerdown', update, { passive: true });
  document.addEventListener('keydown', update);
  reduced.addEventListener('change', update);
  if (connection && connection.addEventListener) connection.addEventListener('change', update);
  // The storefront optimizer can replace the document after this script runs.
  // Re-query the live logo so a replacement cannot strand an unloaded video.
  window.setInterval(update, 1000);
  start();
})();
